import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button} from 'antd'
import {EditOutlined, KeyOutlined, LockOutlined, UnlockOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import PermissionFormModal from './PermissionFormModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
@inject('roleManagementStore', 'permissionManagementStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    permissionModalVisible: false,
    record: null
  }

  componentDidMount() {
    const {roleManagementStore} = this.props
    roleManagementStore.onChangeRoleList([])
    roleManagementStore.onChangePageNo()
    roleManagementStore.onSearchRoleAction({
      name: '',
      status: '',
    }, 1, PAGE_SIZE_DEFAULT)
  }

  handleEdit = (record) => {
    const {roleManagementStore} = this.props
    roleManagementStore.onGetAction(record.id).then(res => {
      this.setState({
        addModalVisible: true
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handlePermission = (record) => {
    const {roleManagementStore, permissionManagementStore} = this.props
    const {searchItem} = permissionManagementStore
    permissionManagementStore.onSearchAction(searchItem, 1, 99999999)
    roleManagementStore.getPermissionRoleAction(record.id).then(res => {
      this.setState({
        permissionModalVisible: true,
        record: record
      })
    })
  }
  handleCancelPermission = () => {
    const {roleManagementStore} = this.props
    roleManagementStore.getRoleUserListData([])
    this.setState({
      permissionModalVisible: false
    })
  }
  handleStatus = (record) => {
    const {roleManagementStore} = this.props
    roleManagementStore.onEditRoleAction({...record, status: record.status ? false : true}, record.id)
    // roleManagementStore.onDeleteRoleAction(record.id)
  }
  handlePageChange = (page, pageSize) => {
    const {roleManagementStore} = this.props
    roleManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {roleManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, roleList} = roleManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(roleList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column align="center" width={80} title={t(`roleManagement.status`)} dataIndex="statusName" key="statusName" render={(text, record, index) =>
            <div style={{
              display: 'inline-block',
              height: 24,
              width: 24,
              lineHeight: '24px',
              fontSize: 12,
              borderRadius: 24,
              color: 'white',
              textAlign: 'center',
              background: text === 'Enable' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'Disable' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : themeStyle?.statusColor?.split(',')?.[2] || '#7ac3e0'
            }}
                 title={text}>{text.charAt(0)}</div>
          }/>
          <Table.Column width={80} title={t(`roleManagement.id`)} dataIndex="id" key="id"
                        render={(text, record, index) => `${(pageNo - 1) * pageSize + (index + 1)}`}/>
          <Table.Column title={t(`roleManagement.roleName`)} dataIndex="name" key="name" ellipsis={true}/>
          <Table.Column title={t(`roleManagement.roleCode`)} dataIndex="key" key="key"/>
          <Table.Column title={t(`roleManagement.description`)} dataIndex="description" key="description" ellipsis={true}/>
          <Table.Column align="center" title="Action" key="Action" render={(text, record) => (
            <>
              <Button onClick={() => this.handlePermission(record)} type="link" disabled={record.status === false} icon={<KeyOutlined/>}
                      title={t(`roleManagement.permission`)}/>
              <Button onClick={() => this.handleEdit(record)} type="link" icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button onClick={() => this.handleStatus(record)} type="link" icon={record.status === false ? <LockOutlined/> : <UnlockOutlined/>}
                      title={record.status === false ? t(`general.enable`) : t(`general.disable`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
        {this.state.permissionModalVisible ? <PermissionFormModal
          permissionModalVisible={this.state.permissionModalVisible}
          handleCancelPermission={this.handleCancelPermission}
          record={this.state.record}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
